<template>
  <app-main>
    <template v-slot:mobileNav>
      <mobile-menu></mobile-menu>
    </template>

    <template v-slot:nav>
      <v-menu></v-menu>
    </template>

    <template v-slot:header>
      <v-header></v-header>
    </template>

    <router-view />

    <portal to="loadingPage">
      <transition name="fade">
        <div class="dashboard-content-loading" v-show="loading">
          <div class="dashboard-content-loading__inner" v-show="loading">
            <spinner width="5"></spinner>
            <br>
            <span class="text--small">{{ $t('views.Dashboard.loading') }}</span>
          </div>
        </div>
      </transition>
    </portal>

    <edit-widget></edit-widget>
  </app-main>
</template>

<script>
import { App } from '@capacitor/app'

import AppMain from '@/ui/layout/AppMain'
import Spinner from '@/ui/elements/Spinner'

import MobileMenu from '@/components/MobileMenu'
import vMenu from '@/components/Menu'
import vHeader from '@/components/Header'

import EditWidget from '@/widgets/EditWidget'

import screen from '@/mixins/screen'
import hasActiveContracts from '@/mixins/hasActiveContracts'
import profile from '@/mixins/profile'
import { refreshingToken } from '@/mixins/handleGraphqlError'

import { MeGQL } from '@/graphql/queries'

export default {
  mixins: [screen, hasActiveContracts, profile, refreshingToken],

  apollo: {
    me: {
      query: MeGQL
    }
  },

  components: {
    AppMain,
    Spinner,
    vMenu,
    MobileMenu,
    vHeader,
    EditWidget
  },

  data () {
    return {
      sortable: null,
      isDragging: false,
      prevRoute: null
    }
  },

  computed: {
    loading () {
      return this.$apollo.queries.me.loading || this.$apollo.queries.profileLoc.loading || this.refreshingToken
    },

    computedShow () {
      return !this.loading
    }
  },

  methods: {},

  mounted () {
    // App.addListener('backButton', async (ev) => {
    //   alert(this.prevRoute.fullPath)
    //   // this.$router.back()
    // })
  },

  beforeDestroy () {
    App.removeAllListeners()
  },

  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },

  watch: {
    me: {
      handler: async function () {
        const hasActiveContracts = this.me && this.me.availableMerchants.length && !this.me.availableMerchants[0].draft
        if (this.me && !hasActiveContracts) {
          try {
            await this.$router.push({ name: 'add-merchant' })
          } catch (e) {}
        }
      },
      deep: true
    }
  }
}
</script>
